import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '@fortawesome/fontawesome-free/css/all.css'
import VueSimpleAlert from "vue-simple-alert";

// BootstrapVue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSimpleAlert);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Font Awesome para Vue 2
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faWifi,
  faCamera,
  faMobileAlt,
  faDesktop,
  faShieldAlt,
  faGamepad,
  faBuilding,
  faHome,
  faShoppingCart,
  faTools,           // ← agregado
  faNetworkWired,    // ← agregado
  faLaptop           // ← agregado
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Agrega los íconos necesarios
library.add(
  faWifi,
  faCamera,
  faMobileAlt,
  faDesktop,
  faShieldAlt,
  faGamepad,
  faBuilding,
  faHome,
  faShoppingCart,
  faTools,
  faNetworkWired,
  faLaptop
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
